import gql from 'graphql-tag';

export const USER_FRAGMENT = gql`
  fragment UsersFields on QualaUser {
    __typename
    id
    displayName
    avatarUrl
    email
    memberships {
      id
      account {
        id
        name
        type
      }
    }
    isAdmin
    isConfirmed
  }
`;

export const ACCOUNT_FRAGMENT = gql`
  fragment AccountFields on Account {
    id
    name
    type
    owner {
      id
      email
    }
  }
`;

export const NOTEBOOK_FRAGMENT = gql`
  fragment NotebookFields on Notebook {
    id
    name
    isDemo
    isArchived
    createdAt
  }
`;

export const GROUP_FRAGMENT = gql`
  fragment GroupFields on Group {
    id
    name
    slug
    description
    owner {
      id
    }
  }
`;

export const GROUP_MEMBER_FRAGMENT = gql`
  fragment GroupMemberFields on GroupMember {
    id
    member {
      id
      displayName
      user {
        id
        email
        avatarUrl
      }
    }
    roleType
    membershipStatus
  }
`;

export const TRACKER_FRAGMENT = gql`
  fragment TrackerFields on Tracker {
    id
    name
    slug
    purpose
    type
    active
    groups {
      id
      name
      slug
    }
  }
`;

export const SUBJECT_FRAGMENT = gql`
  fragment SubjectFields on Subject {
    id
    name
    slug
    description
    groups {
      id
      name
      slug
    }
  }
`;

export const FULL_NOTE_FRAGMENT = gql`
  fragment FullNote on Note {
    id
    content
    context
    notedAt
    composedBy {
      id
      displayName
      user {
        id
        email
        avatarUrl
      }
    }
    subjects {
      ...SubjectFields
    }
    measurements {
      id
      value
      subject {
        ...SubjectFields
      }
      tracker {
        ...TrackerFields
      }
    }
  }
  ${SUBJECT_FRAGMENT}
  ${TRACKER_FRAGMENT}
`;

export const SUBJECT_MEMBER_FRAGMENT = gql`
  fragment SubjectMemberFields on SubjectMember {
    id
    member {
      id
      displayName
      user {
        id
        email
        avatarUrl
      }
    }
    roleType
    membershipStatus
  }
`;
